<template>
  <div>
    <div v-if="detailData.files.length > 0" class="previewUploadFiles">
      <div v-for="(file, i) in detailData.files" :key="i" class="previewUploadFile">
        <img v-if="detailData.previewType === 'image'" :src="file.path" alt="">
        <div v-else-if="detailData.previewType === 'filename'">{{file.name}}</div>
        <button type="button" class="delFile" @click="uploadFileDelete(i)"></button>
      </div>
    </div>
    <label v-if="detailData && uploadFileActive(detailData)" class="moduleLink">
      <input type="file" :accept="`${detailData.type}/*`" @click="uploadFileLimit($event, detailData)" @change="uploadFile($event, detailData.type)">
    </label>
  </div>
  <!-- <div class="formGroup">
    <div class="label">
      <p>upload</p>
    </div>
    <div>{{value}}</div>
  </div> -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UNIQUE from '@/common/unique'

export default {
  name: 'Upload',
  props: [
    'id',
    'columnId',
    'lang',
    'locale',
    'detailData',
    'getSubmitData'
  ],
  computed: {
    value: {
      get () {
        const data = typeof (this.getSubmitData.find(x => x.id === this.columnId)) === 'undefined' ? '' : this.getSubmitData.find(x => x.id === this.columnId).value
        return data
      },
      set (value) {
      }
    },
    passed () {
      return this.getSubmitData && this.getSubmitData.find(x => x.id === this.id)
        ? this.getSubmitData.find(x => x.id === this.id).passed
        : null
    }
  },
  data () {
    return {
    }
  },
  methods: {
    uploadFile (e, type) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0],
        ...getFileInfo(e.target.files[0].type)
      }
      const blobToBase64 = (blob, type) => {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        return new Promise(resolve => {
          reader.onloadend = () => {
            resolve(reader.result)
          }
        })
      }
      function getFileInfo (typeInfo) {
        const type = typeInfo.split('/')[0]
        const format = typeInfo.split('/')[1]
        // const isValid = regExp[type] && regExp[type].test(format.toLowerCase())
        return {
          type: type,
          format: format
        }
      }
      function getFileSize (size) {
        return size / 1024 / 1024
      }
      if (data.file) {
        if (data.type) {
          if (data.type.includes('image')) {
            this.$store.dispatch('util/setImage', data).then((blob) => {
              if (blob) {
                if (getFileSize(data.file.size) > 5) {
                  // 이미지 파일은 최대 5MB까지 업로드 가능합니다.
                  alert(this.locale.alert_upload_image_size)
                } else {
                  const fileName = blob.name
                  const detailUpload = this.detailData.files || []
                  const uploadData = {
                    id: UNIQUE.mid(),
                    file: blob
                  }
                  this.$store.dispatch('util/uploadFile', uploadData).then((res) => {
                    const files = detailUpload.concat({
                      id: data.id,
                      path: res.source,
                      name: fileName,
                      previewType: this.detailData.previewType
                    })
                    const valueData = {
                      type: 'upload',
                      id: this.columnId,
                      value: files,
                      passed: true
                    }
                    this.detailData.files = files
                    this.$emit('setValue', valueData)
                  })
                }
              }
            })
            // } else if (data.type.includes('video')) {
            /*
            if (window.confirm(this.locale.confirm_upload_video)) {
              if (getFileSize(data.file.size) > 20) {
                // 동영상 파일은 최대 20MB까지 업로드 가능합니다.
                alert(this.locale.alert_upload_video_size)
              } else {
                this.uploading = true
                data.cid = this.cid
                data.msgId = UNIQUE.mid()
                data.fileName = `${data.id}-${data.file.name}`
                Object.assign(data, this.user)
                this.scrollBottom()
                this.$store.dispatch('talk/resizeVideo', data).then((res) => {
                  if (res && res.status === 200) {
                    const videoData = {
                      key: data.fileName,
                      body: data.file
                    }
                    this.$store.dispatch('talk/uploadVideo', videoData).then((res) => {
                      if (!(res && res.Key && res.Location)) {
                        alert(this.locale.alert_upload_fail)
                        this.uploading = false // 업로드 응답 후 ws반응이 많이 느리기 때문에 성공시에는 add card에서 uploading 끔
                      }
                    })
                  } else {
                    alert(this.locale.alert_upload_fail)
                    this.uploading = false
                  }
                })
              }
            }
            */
          } else {
            // 지원하지 않는 형식의 파일입니다.\n이미지: png, jpeg, gif\n동영상: mp4, ogg, webm
            alert(`${this.locale.alert_upload_format_not_support}\n${this.locale.alert_upload_image_video_only}`)
          }
        } else {
          // 지원하지 않는 형식의 파일입니다.\n이미지: png, jpeg, gif\n동영상: mp4, ogg, webm
          alert(`${this.locale.alert_upload_format_not_support}\n${this.locale.alert_upload_image_video_only}`)
        }
      } else {
        alert(this.locale.alert_attach_fail)
      }
      e.target.value = ''
    },
    uploadFileActive (upload) {
      const limit = parseInt(upload.count)
      const length = parseInt(upload.files.length)
      return upload.active && length < limit
    },
    uploadFileLimit (e, upload) {
      const limit = parseInt(upload.count)
      const length = parseInt(upload.files.length)
      if (length >= limit) {
        // alert(`최대 ${limit}개 까지 업로드 가능합니다.`)
        const message = this.locale.alert_upload_count_limit.replace('{var}', limit)
        alert(message)
        e.preventDefault()
      }
      return length >= limit
    },
    uploadFileDelete (index) {
      if (window.confirm(this.locale.confirm_delete_image)) {
        this.detailData.files = this.detailData.files.filter((x, i) => i !== index)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.previewUploadFiles {
  position: relative;
  z-index: 3;
}
</style>
